import React, { useRef, useEffect } from 'react';
import { getPlayerIdByName } from "../../../../Controllers/PlayerRankingApi";
import { actions } from "../../../../Redux/store";
import { useMixpanel } from '../../../../Context/MixpanelContext/MixpanelProvider';
import tableClick from "../../../../assets/imgs/table-click.svg"

interface InteractiveTableProps {
  children: React.ReactNode;
  [key: string]: any;
}

const InteractiveTable: React.FC<InteractiveTableProps> = ({
  children,
  ...props
}) => {
  const tableRef = useRef<HTMLTableElement>(null);
  const Mixpanel = useMixpanel();

  useEffect(() => {
    if (tableRef.current) {
      const table = tableRef.current;
      const headers = table.querySelectorAll("thead th");

      // Find if "Player" or "Player Name" column exists and get its index
      let playerColumnIndex = -1;

      headers.forEach((header, index) => {
        const headerText = header.textContent?.trim().toLowerCase();
        if (headerText === "player" || headerText === "player name" || headerText === "quarterback" ||  headerText === "runningback" || headerText === "widereceiver" || headerText === "tightend"  ) {
          playerColumnIndex = index;
        }
      });

      // If we found the player column, make those cells interactive
      if (playerColumnIndex !== -1) {
        const playerCells = table.querySelectorAll(
          `tbody tr td:nth-child(${playerColumnIndex + 1})`,
        );

        playerCells.forEach((cell) => {
          const htmlCell = cell as HTMLTableCellElement;
          htmlCell.style.cursor = "pointer";
          htmlCell.classList.add("interactive-player-cell");

          // Get the original player name before modifying the cell
          const originalPlayerName = htmlCell.textContent?.trim();

          // Create a flex container for the player name and icon
          const flexContainer = document.createElement("span");
          flexContainer.style.display = "flex";
          flexContainer.style.flexDirection = "row";
          flexContainer.style.alignItems = "center";
          flexContainer.style.gap = "10px";

          // Create span element for player name with the table-data-span class
          const playerNameSpan = document.createElement("span");
          playerNameSpan.className = "table-data-span";
          playerNameSpan.textContent = originalPlayerName || "";

          // Create image element for the table click icon
          const clickIcon = document.createElement("img");
          clickIcon.src = tableClick;
          clickIcon.alt = "Click to view player";
          clickIcon.style.width = "10px";
          clickIcon.style.height = "10px";
          clickIcon.style.marginTop = "0";
          clickIcon.style.marginBottom = "0";
           clickIcon.style.marginRight = "5px";

          // Append text span and icon to flex container
          flexContainer.appendChild(playerNameSpan);
          flexContainer.appendChild(clickIcon);

          // Replace cell content with flex container
          htmlCell.innerHTML = "";
          htmlCell.appendChild(flexContainer);

          // Add click handler
          htmlCell.addEventListener("click", async () => {
            const playerName = originalPlayerName;

            try {
              console.log("Fetching player ID for:", playerName);
              Mixpanel.trackEvent("chatbot_player_name_clicked", {
                name: "User clicked on the player name in the chatbot",
                playerName: playerName,
              });
              const response = await getPlayerIdByName(playerName);

              const playerId = response?.data?.[0]?.roto_player_id;
              if (playerId) {
                
                actions.modal.openPlayerProfileModal({ playerId: playerId });

                console.log("Player ID:", playerId);
              } else {
                console.warn("Player ID not found for:", playerName);
              }
            } catch (error) {
              console.error("Error fetching player data:", error);
            }
          });
        });
      }
    }
  }, [children]);

  return (
    <div className="overflow-x-auto my-4">
      <table
        ref={tableRef}
        className="border-collapse w-full table-auto !border-spacing-0"
        style={{ borderCollapse: "collapse", width: "100%" }}
        {...props}
      >
        {children}
      </table>
    </div>
  );
};

export default InteractiveTable;
